import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowDataService } from '../data-table/workflow-data.service';
import { Software } from '../models/software/software';

@Injectable({
  providedIn: 'root',
})
export class SoftwareService extends WorkflowDataService<Software> {
  protected override get apiEndpoint(): string {
    return '/software';
  }

  getLatestPublicDownloadLink(id: string): Observable<string> {
    return this.http.get<string>(`${this.apiEndpoint}/${id}/latest-download`);
  }
}
